import React from 'react';

export const Move = ({ height="31px", width="36px",padding="12px",style=''})=> (
    <svg className = "chatLanding-support-XA3-item-grid-image" role="presentation" aria-label="" padding={padding} viewBox="0 0 36 31" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
            <g>
                <rect width="24" height="24" fill="none" />
                <path d="M21.75,7.7a.77.77,0,0,0-.4-.67l-9-4.7a.73.73,0,0,0-.69,0L2.65,7a.75.75,0,0,0-.4.67h0v8.6a.75.75,0,0,0,.4.66l9,4.7h0a.74.74,0,0,0,.34.1.81.81,0,0,0,.34-.08l9-4.5a.73.73,0,0,0,.42-.67V7.7ZM12,11.17,9.17,9.82l7.12-3.73,3,1.58Zm0-7.32,2.68,1.39L7.48,9,4.68,7.67Zm-8.24,5,7.5,3.59v7.28l-7.5-3.92Zm9,10.9V12.48l7.5-3.59V16ZM9.9,15.9v1.69l-3.8-2V13.91Z" />
            </g>
        </g>
    </svg>
);
